<div class="max-h-[95vh] overflow-visible bg-[#EFEFEF] shadow-[0_0_18px_4px_rgba(0,0,0,0.24)]">
  <mat-dialog-actions class="!bg-[#EFEFEF] !px-5 !pt-5">
    <div class="flex w-full">
      <h1 class="text-2xl">{{appointmentDetailParams.patientName}}</h1>
      <span class="flex-auto"></span>
      <button matButton (click)="handleClose()" aria-label="Close dialog">
        <mat-icon inline class="!text-[20px]">close</mat-icon>
      </button>
    </div>
    <div class="mt-[10px]">
      <strong>DOB</strong>
      <div>{{appointmentDetailParams.dateOfBirth}}</div>
    </div>
    @if (isWcUser) {
      <div class="mt-[10px] flex w-full">
        @if (detailData.isLoading()) {
          <div class="max-w-full animate-pulse">
            <div
              class="block w-56 h-3 font-sans text-5xl antialiased font-semibold leading-tight tracking-normal bg-gray-300 rounded-full text-inherit">
              &nbsp;
            </div>
          </div>
        } @else {
          @for (appointmentsByCase of detailData.value()?.expandedAppointments; track appointmentsByCase) {
            <ng-container class="header-accordion">
              <simple-collapsible title="Case info" class="min-w-[30%]">
                <div class="space-y-[10px] p-[10px]">
                  <div>
                    <strong>Employer:</strong>
                    <div>{{appointmentsByCase.caseInfo?.employer}}</div>
                  </div>
                  <div>
                    <strong>Insurance:</strong>
                    @if (appointmentsByCase.caseInfo?.insurance !== null) {
                      <div>{{appointmentsByCase.caseInfo.insurance}}</div>
                    } @else {
                      <div>
                        No insurance information on file
                      </div>
                    }
                  </div>
                  <div>
                    <strong>Case Managers:</strong>
                    @for (caseManager of appointmentsByCase.caseInfo.caseManagers; track caseManager) {
                      <div>{{caseManager}}</div>
                    }
                  </div>
                  <div>
                    <strong>Date of Injury:</strong>
                    @if (appointmentsByCase.caseInfo?.onsetDate !== null) {
                      <div>{{appointmentsByCase.caseInfo.onsetDate | dateFormat:'MM/DD/YYYY'}}</div>
                    } @else {
                      <div>
                        No date of injury information on file
                      </div>
                    }
                  </div>
                </div>
              </simple-collapsible>
            </ng-container>
          }
        }
      </div>
    }
  </mat-dialog-actions>

  <ng-container
    *ngTemplateOutlet="readOnlyModeTemplate">
  </ng-container>

  <ng-template #readOnlyModeTemplate>
    <div class="m-0 block max-h-[65vh] grow overflow-auto box-border bg-[#EFEFEF] px-5 pb-[10px]">
      @if (detailData.isLoading()) {
        <div class="mb-[52px] flex w-full items-center justify-center"><mat-spinner></mat-spinner></div>
      }
      @for (appointmentsByCase of detailData.value()?.expandedAppointments; track appointmentsByCase) {
        @if (appointmentsByCase.appointments.count !== 0 && appointmentsByCase.caseInfo !== null) {
          <strong>Claim No:</strong>
          <div>{{appointmentsByCase.caseInfo.policyNumber}}</div>
        }
        @for (appointment of appointmentsByCase.appointments.items; track appointment; let i = $index) {
          <app-appointment-detail
            [appointment]="appointment"
            [caseInfo]="appointmentsByCase.caseInfo"
            [showDocumentsTable]="shouldShowDocumentsTable"
            [appointmentType]="appointmentDetailParams.appointmentType"
            [isMultiAppointment]="appointmentDetailParams.appointmentType === appointmentType.PatientSearch"
            [isExpanded]="i === 0"
          ></app-appointment-detail>
        }
      }
    </div>
  </ng-template>
</div>
